import {DragSource, DropTarget} from 'react-dnd'
import {Button} from '@amzn/awsui-components-react'
import React from "react";


class DragButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <span>{this.props.connectDragSource(<span style={{display: 'inline-block'}}><Button
      variant="icon" icon="menu"/></span>)}</span>;
  }
}

const Types = {
  CARD: 'card'
}

const dragSpec = {

  beginDrag(props, monitor, component) {
    return {data: props.data};
  },

  endDrag(props, monitor, component) {
    if (monitor.didDrop()) {
      const initialItem = monitor.getItem().data;
      const targetItem = monitor.getDropResult().data;
      props.onChange(initialItem, targetItem);
    }
  }
}

const dragCollect = function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}



const ds = DragSource(Types.CARD, dragSpec, dragCollect)(DragButton)
export {ds as DragButton, Types}